import { BulkLoads } from '../../../../types'

import type { Texts } from './useTexts'

const maxLoadValue = 5000000

export const createValidateLoads = (texts: Texts, bulkLoads: BulkLoads) => {
  if (bulkLoads) {
    const invalidLoads = Object.values(bulkLoads.exact).reduce<
      Record<string, { name?: string; value?: string }>
    >((acc, curr) => {
      const error: { name?: string; value?: string } = {}

      if (curr.name === '') {
        error.name = texts.invalidName
      } else if (curr.name.length > 30) {
        error.name = texts.invalidLoadExceedMaxCharacters
      }

      if (curr.value === null) {
        error.value = texts.invalidValue
      } else if (curr.value <= 0) {
        error.value = texts.invalidLoadLessThanZero
      } else if (curr.value > maxLoadValue) {
        error.value = texts.invalidLoadExceedMaxValue
      }

      if (error.name || error.value) {
        acc[curr.name] = error
      }
      return acc
    }, {})

    const hasInvalidLoads = Object.keys(invalidLoads).length > 0

    if (hasInvalidLoads) {
      return JSON.stringify(invalidLoads)
    }
  }
}
